export class SessionStorageService {

  constructor() {
  }

  public getAccessToken(): string | null {
    return localStorage.getItem("accessToken");
  }

  public setAccessToken(accessToken: any) {
    return localStorage.setItem("accessToken", accessToken);
  }

  public setTahsilatUserInfo(userInfo: any) {
    return sessionStorage.setItem("userInfo", JSON.stringify(userInfo));

  }

  public getTahsilatUserInfo(): any {
    return JSON.parse(sessionStorage.getItem('userInfo') as any);
  }
  public setUserInfo(userInfo: any) {
    return sessionStorage.setItem("user", JSON.stringify(userInfo));

  }

  public getUserInfo(): any {
    return JSON.parse(sessionStorage.getItem('user') as any);
  }
  public clearAll() {
    localStorage.clear();
    sessionStorage.clear();
  }
}

export default new SessionStorageService();